import Swiper from 'swiper';
import { Pagination, Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

document.addEventListener('DOMContentLoaded', () => {
	const quoteSliders = document.querySelectorAll('.quote-slider');

	if (quoteSliders.length) {
		quoteSliders.forEach((slider) => {
			const swiperEl = slider.querySelector('.quote-swiper');
			const paginationEl = slider.querySelector('.quote-pagination');

			new Swiper(swiperEl, {
				modules: [Pagination, Autoplay, EffectFade],
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},
				loop: true,
				speed: 700,
				autoplay: {
					delay: 6000,
					pauseOnMouseEnter: true,
					//disableOnInteraction: true,
				},
				pagination: {
					el: paginationEl,
					clickable: true,
				},
			});
		});
	}
});
